export default {
  register_time: '注册时间',
  authorization_status: '授权状态',
}
